import { Component, Input } from '@angular/core';
import { ActivatableItemCount, ActivationStatus } from '../../../../core/interface';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-activatable-package-items-row]',
  templateUrl: './activatable-package-items-row.component.html',
  styleUrls: ['./activatable-package-row.component.scss'],
  standalone: false,
})
export class ActivatablePackageItemsRowComponent {
  @Input() activatableItemCount: ActivatableItemCount;
  @Input() hidePricing: boolean;

  pendingStatus = ActivationStatus.PENDING;
  activatedStatus = ActivationStatus.ACTIVATED;
  cancelledStatus = ActivationStatus.CANCELED;

  public getBillingId(): string {
    if (!this.activatableItemCount?.editionId) {
      return this.activatableItemCount?.activatableItem?.billingId;
    }
    const editionId = this.activatableItemCount.editionId;
    const editions = this.activatableItemCount.activatableItem?.editionData?.editions || [];
    const editionBillingId = editions.find((ed) => ed.editionId === editionId)?.billingId;
    return editionBillingId || this.activatableItemCount.activatableItem?.billingId;
  }

  usesEdition(): boolean {
    return (
      this.activatableItemCount.activatableItem.editionData &&
      this.activatableItemCount.activatableItem.editionData.usesEditions &&
      !!this.activatableItemCount.editionName
    );
  }
}
